export class RegisterUser{
    constructor(
        public identificacion : string,
        public email : string,
        public email2 : string,
        public telefono : string,
        public tipoUsuario : string,
        public numBeneficiario : string,
        public numContrato : string,
        public aceptaCondiciones : boolean,
        public aceptaRecibirInfo : boolean
    ){}
}


// WEBPACK FOOTER //
// /app/src/app/shared/models/register-user.model.ts